// extracted by mini-css-extract-plugin
module.exports = {"svg":"lines-module--svg--3ut0T","white":"lines-module--white--1YHnq","yellow":"lines-module--yellow--222CR","green":"lines-module--green--3qURn"};